// Standard api calls
import request from 'superagent'
import { API_URL } from './const'
import { get, keys, mapKeys } from 'lodash'
import { withToken, extractBody } from './helpers'

const alignDjPagination = data => {
  return mapKeys(data, (value, key) => {
    switch (key) {
      case 'count':
        return 'total_items'
      case 'results':
        return 'items'
      case 'previous':
        return 'prev'
      default:
        return key
    }
  })
}

export const getCategories = token => () =>
  withToken(token, request.get(`${API_URL}/categories`)).then(extractBody)

export const getDistricts = token => () =>
  withToken(token, request.get(`${API_URL}/districts`)).then(extractBody)

export const getItems = token => (params = {}) => {
  // Should call ma men Django?
  const callDj =
    get(params, 'genere', '').length > 0 ||
    !!get(params, 'district_id') ||
    keys(get(params, 'attributi', {})).length > 0
  const endpoint = callDj ? 'djitems' : 'items'

  return withToken(
    token,
    request.get(`${API_URL}/${endpoint}`).query({
      ...params,
      attributi: JSON.stringify(get(params, 'attributi', {})),
    })
  )
    .then(extractBody)
    .then(data => {
      if (callDj) {
        return alignDjPagination(data)
      }
      return data
    })
}

export const getOwnedItems = token => (params = {}) =>
  withToken(token, request.get(`${API_URL}/haves`).query(params)).then(
    extractBody
  )

export const getWantedItems = token => (params = {}) =>
  withToken(token, request.get(`${API_URL}/wants`).query(params)).then(
    extractBody
  )

export const getInterestItems = token => (params = {}) =>
  withToken(token, request.get(`${API_URL}/interests`).query(params)).then(
    extractBody
  )

export const getItemsICanGet = token => (params = {}) =>
  withToken(
    token,
    request.get(`${API_URL}/swaps/items/get`).query(params)
  ).then(extractBody)

export const getItemsICanGive = token => (params = {}) =>
  withToken(
    token,
    request.get(`${API_URL}/swaps/items/give`).query(params)
  ).then(extractBody)

export const getSwaps = token => (params = {}) =>
  withToken(token, request.get(`${API_URL}/swaps`).query(params)).then(
    extractBody
  )

export const getMessages = token => (params = {}) =>
  withToken(token, request.get(`${API_URL}/messages`).query(params)).then(
    extractBody
  )

export const getMessage = token => id =>
  withToken(token, request.get(`${API_URL}/messages/${id}`)).then(extractBody)

export const sendMessage = token => (toUserId, text) =>
  withToken(
    token,
    request.post(`${API_URL}/messages`).send({
      user_to: toUserId,
      text: text,
    })
  ).then(extractBody)

export const markMessageAsRead = token => id =>
  withToken(
    token,
    request.patch(`${API_URL}/messages/${id}`).send({ read: true })
  ).then(extractBody)

export const getUserInfo = token => idOrUsername =>
  withToken(token, request.get(`${API_URL}/users/${idOrUsername}/info`)).then(
    extractBody
  )

// Counts calls

export const countEcoins = token => () =>
  withToken(token, request.get(`${API_URL}/user/ecoins`)).then(extractBody)

export const countItemsICanGet = token => (params = {}) =>
  withToken(
    token,
    request.get(`${API_URL}/swaps/items/get`).query({
      ...params,
      count_only: 1,
    })
  )
    .then(extractBody)
    .then(data => +data.total_items)

export const countNewSwaps = token => () =>
  withToken(
    token,
    request.get(`${API_URL}/swaps`).query({
      type: 'proposte_a_me',
      status: 'proposta',
    })
  )
    .then(extractBody)
    .then(data => +data.total_items)

export const countOwnedItems = token => () =>
  withToken(token, request.get(`${API_URL}/haves`).query({ count_only: 1 }))
    .then(extractBody)
    .then(data => +data.total_items)

export const countWantedItems = token => () =>
  withToken(token, request.get(`${API_URL}/wants`).query({ count_only: 1 }))
    .then(extractBody)
    .then(data => +data.total_items)

export const countOwnedItemsOfUser = token => id =>
  withToken(
    token,
    request.get(`${API_URL}/haves`).query({ user_id: id, count_only: 1 })
  )
    .then(extractBody)
    .then(data => +data.total_items)

export const countWantedItemsOfUser = token => id =>
  withToken(
    token,
    request.get(`${API_URL}/wants`).query({ user_id: id, count_only: 1 })
  )
    .then(extractBody)
    .then(data => +data.total_items)

export const countItemsICanGetFromOtherUser = token => id =>
  withToken(
    token,
    request
      .get(`${API_URL}/swaps/items/get`)
      .query({ swapper_id: id, count_only: 1 })
  )
    .then(extractBody)
    .then(data => +data.total_items)

export const getItemDetail = token => (id, params = {}) =>
  withToken(token, request.get(`${API_URL}/items/${id}`).query(params)).then(
    extractBody
  )

export const iWant = token => id =>
  withToken(token, request.post(`${API_URL}/wants`).send({ id })).then(
    extractBody
  )

export const iWantNot = token => id =>
  withToken(token, request.del(`${API_URL}/wants/${id}`)).then(extractBody)

export const iOwn = token => (id, conditions) =>
  withToken(
    token,
    request.post(`${API_URL}/haves`).send({ id, ...conditions })
  ).then(extractBody)

export const iOwnNot = token => id =>
  withToken(token, request.del(`${API_URL}/haves/${id}`)).then(extractBody)

export const removeInterest = token => id =>
  withToken(token, request.del(`${API_URL}/interests/${id}/delete`)).then(
    extractBody
  )

export const updateOwnedItem = token => (id, conditions) =>
  withToken(
    token,
    request.patch(`${API_URL}/haves/${id}?user_id=2`).send(conditions)
  ).then(extractBody)

export const getSwapDetail = token => id =>
  withToken(token, request.get(`${API_URL}/swaps/${id}`)).then(extractBody)

export const acceptSwap = token => (id, updatedAt) =>
  withToken(token, request.post(`${API_URL}/swaps/${id}/actions/accept`))
    .send({ updated_at: updatedAt })
    .then(extractBody)

export const hideSwap = token => id =>
  withToken(token, request.post(`${API_URL}/swaps/${id}/actions/hide`)).then(
    extractBody
  )

export const rejectSwap = token => (id, reason, updatedAt) =>
  withToken(token, request.post(`${API_URL}/swaps/${id}/actions/reject`))
    .send({ reason, updatedAt })
    .then(extractBody)

export const cancelSwap = token => id =>
  withToken(token, request.post(`${API_URL}/swaps/${id}/actions/cancel`)).then(
    extractBody
  )

export const addItem = token => item =>
  withToken(token, request.post(`${API_URL}/items`).send(item)).then(
    extractBody
  )

export const addInterest = token => interest =>
  withToken(token, request.post(`${API_URL}/interests`).send(interest)).then(
    extractBody
  )

export const feedbackSwap = token => (id, rating, reason) =>
  withToken(
    token,
    request
      .post(`${API_URL}/swaps/${id}/actions/feedback`)
      .send({ rating, reason })
  ).then(extractBody)

export const archiveSwap = token => id =>
  withToken(token, request.post(`${API_URL}/swaps/${id}/actions/archive`)).then(
    extractBody
  )

export const createNewSwap = token => swap =>
  withToken(token, request.post(`${API_URL}/swaps`).send(swap)).then(
    extractBody
  )

export const updateSwap = token => (id, swap) =>
  withToken(token, request.put(`${API_URL}/swaps/${id}`).send(swap)).then(
    extractBody
  )

export const updateUser = token => userData =>
  withToken(
    token,
    request.patch(`${API_URL}/user`).send({
      fos_user_profile_form: userData,
    })
  ).then(extractBody)

export const deleteUser = token => () =>
  withToken(token, request.delete(`${API_URL}/user`)).then(extractBody)

export const updatePassword = token => (currentPassword, newPassword) =>
  withToken(
    token,
    request.post(`${API_URL}/passwords/changes`).send({
      fos_user_change_password_form: {
        current_password: currentPassword,
        plainPassword: {
          first: newPassword,
          second: newPassword,
        },
      },
    })
  ).then(extractBody)

export const getAttributeValues = token => attribute =>
  withToken(
    token,
    request.get(`${API_URL}/attributes/${attribute}/values`)
  ).then(extractBody)

export const getAttributeValuesWithCount = token => (
  attribute,
  categoryId,
  q = '',
  crossFilters = {},
  posseduto
) =>
  withToken(
    token,
    request.get(`${API_URL}/attributes-values/${attribute}/`).query({
      q,
      posseduto: posseduto ? 1 : undefined,
      cross_filters: JSON.stringify(crossFilters),
      cat_id: categoryId,
    })
  ).then(extractBody)

export const getGenereValues = token => (
  categoryId,
  q = '',
  crossFilters = {},
  posseduto
) =>
  withToken(
    token,
    request.get(`${API_URL}/genere/`).query({
      q,
      posseduto: posseduto ? 1 : undefined,
      cross_filters: JSON.stringify(crossFilters),
      cat_id: categoryId,
    })
  ).then(extractBody)

export const buyItem = token => (itemId, ownerId, userId, money) =>
  withToken(
    token,
    request.post(`${API_URL}/swaps`).send({
      user_from: {
        id: userId,
        ecoin: money,
      },
      user_to: {
        id: ownerId,
        items: [itemId],
      },
    })
  ).then(extractBody)



// WEBPACK FOOTER //
// ./src/api/calls.js